
import { Component, Vue, Prop } from 'vue-property-decorator';

import { Carousel3d, Slide } from 'vue-carousel-3d';

@Component({
  components: {
    Carousel3d,
    Slide,
  },
})
export default class CPSkeletonLoader extends Vue {

  @Prop({ required: false, default: 'list'})
  public type!: string;

  @Prop({ required: false })
  public title!: boolean;

  @Prop({ required: false })
  public lines!: number;

  @Prop({ required: false, default: '100%' })
  public height!: string;

  @Prop({ required: false, default: '100%' })
  public width!: string;

}
